import Store from "../../../../Store/Store";

class UnitServiceStatusTypeContainer {
  public pickIdFromLabel(label) {
    const UnitServiceStatusType = Store.getConfigurator().getState().globalTypes?.UnitServiceStatus

    for (const key in UnitServiceStatusType) {
      if (UnitServiceStatusType[key].label.toLowerCase() === label.toLowerCase()) {
        return UnitServiceStatusType[key].id
      }
    }
  }

  public pickLabelFromId(id) {
    const UnitServiceStatusType = Store.getConfigurator().getState().globalTypes?.UnitServiceStatus

    for (const key in UnitServiceStatusType) {
      if (UnitServiceStatusType[key].id === id) {
        return UnitServiceStatusType[key].label
      }
    }
  }
}

export default new UnitServiceStatusTypeContainer();
